export const ENSURE_AUTH_USER = "ENSURE_AUTH_USER"
export const SAVE_USER_ROUTES = "SAVE_USER_ROUTES"

export const RESET_PASSWORD = "RESET_PASSWORD"
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS"

export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"

export const GET_FEATURES_AVAILABLE = "GET_FEATURES_AVAILABLE"
export const GET_FEATURES_AVAILABLE_SUCCESS = "GET_FEATURES_AVAILABLE_SUCCESS"

export const GET_CLIENT_CONFIG = "GET_CLIENT_CONFIG"
export const GET_CLIENT_CONFIG_SUCCESS = "GET_CLIENT_CONFIG_SUCCESS"

export const GET_USER_PERMISSIONS = "GET_USER_PERMISSIONS"
export const GET_USER_PERMISSIONS_SUCCESS = "GET_USER_PERMISSIONS_SUCCESS"

export const SWITCH_CLIENT = "SWITCH_CLIENT"
export const SWITCH_CLIENT_SUCCESS = "SWITCH_CLIENT_SUCCESS"

export const SOCIAL_LOGIN = "SOCIAL_LOGIN"

export const UPDATE_AUTH_USER_DATA = "UPDATE_AUTH_USER_DATA"

export const SET_2FA_TOKEN = "SET_2FA_TOKEN"

export const VALIDATE_2FA = "VALIDATE_2FA"
export const VALIDATE_2FA_SUCCESS = "VALIDATE_2FA_SUCCESS"
export const VALIDATE_2FA_FAILED = "VALIDATE_2FA_FAILED"

export const RESEND_2FA_CODE = "RESEND_2FA_CODE"
export const RESEND_2FA_CODE_SUCCESS = "RESEND_2FA_CODE_SUCCESS"
export const RESEND_2FA_CODE_FAILED = "RESEND_2FA_CODE_FAILED"
